/*
 * 基于字段配置，生成初始数据
 */
import { useEffect, useState } from 'react';
import type { UseModelDefaultValues } from './type';
import { jsonataFactory } from '@/utils';


export function getModelInitData(mergeRecordFormColumns: any) {
  if (!mergeRecordFormColumns) {
    return null;
  }
  const values: Record<string, any> = {};
  mergeRecordFormColumns.forEach((column: any) => {
    const defaultValue = column.defaultValue || column.moduleField?.extension?.defaultValue;
    if (defaultValue) {
      if (/\$[a-z_A-Z0-9]+\(.*?\)/.test(defaultValue)) {
        const expression = jsonataFactory(defaultValue);
        values[column.dataIndex] = expression.evaluate({});
      } else {
        values[column.dataIndex] = defaultValue;
      }
    }
  });
  return values;
}

export const useModelDefaultValues = ({
  recordID,
  mergeRecordFormColumns,
}: UseModelDefaultValues) => {
  const [modelDefaultValues, setModelDefaultValues] = useState<null | Record<string, any>>(null);
  useEffect(() => {
    // 初始化,在创建页 数据只执行一次
    if (Array.isArray(mergeRecordFormColumns) && mergeRecordFormColumns.length > 0 && !modelDefaultValues && recordID === '0') {
      setModelDefaultValues(
        getModelInitData(mergeRecordFormColumns),
      );
    }
  }, [mergeRecordFormColumns]);
  return {
    modelDefaultValues,
  };
};

